export default __webpack_public_path__ + "static/media/lock.29bf6c74.svg";